const FEATURES_DATA_RU = [
  {
    name: "clients",
    color: "#319DED",
    title: "Клиентская база",
    description: "Управляйте клиентской базой",
    image: require("../../../../images/features/feature_clients.png"),
  },
  {
    name: "subscriptions",
    color: "#02B799",
    title: "Учет абонементов",
    description: "Создавайте абонементы из шаблонов",
    image: require("../../../../images/features/feature_subscriptions.png"),
  },
  {
    name: "tasks",
    color: "#E75D49",
    title: "Планировщик задач",
    description: "Ставьте задачи сотрудникам через планировщик",
    image: require("../../../../images/features/feature_tasks.png"),
  },
  {
    name: "mobile",
    color: "#762BDA",
    title: "Мобильная версия",
    description: "Работайте с телефона",
    image: require("../../../../images/features/feature_mobile.png"),
  },
  {
    name: "wages",
    color: "#F2A819",
    title: "Расчет зарплат",
    description: "Автоматизируйте расчет зарплат",
    image: require("../../../../images/features/feature_wages.png"),
  },
  {
    name: "analytics",
    color: "#319DED",
    title: "Отчеты и аналитика",
    description: "Подружитесь с аналитикой",
    image: require("../../../../images/features/feature_analytics.png"),
  },
  {
    name: "portal",
    color: "#762BDA",
    title: "Личные кабинеты",
    description: "Делитесь информацией с учениками в два клика",
    image: require("../../../../images/features/feature_portal.png"),
  },
]

const FEATURES_DATA_EN = [
  {
    name: "clients",
    color: "#319DED",
    title: "Customer data",
    description: "Manage customer information",
    image: require("../../../../images/features/feature_clients.png"),
  },
  {
    name: "subscriptions",
    color: "#02B799",
    title: "Subscriptions and registration forms",
    description: "Use membership templates",
    image: require("../../../../images/features/feature_subscriptions.png"),
  },
  {
    name: "tasks",
    color: "#E75D49",
    title: "Tasks for employees",
    description: "Schedule tasks for employees",
    image: require("../../../../images/features/feature_tasks.png"),
  },
  {
    name: "mobile",
    color: "#762BDA",
    title: "Mobile version",
    description: "Work from your phone",
    image: require("../../../../images/features/feature_mobile.png"),
  },
  {
    name: "wages",
    color: "#F2A819",
    title: "Payroll and finance",
    description: "Automate payroll and finance",
    image: require("../../../../images/features/feature_wages.png"),
  },
  {
    name: "analytics",
    color: "#319DED",
    title: "Analytics and reports",
    description: "Analyze your stats",
    image: require("../../../../images/features/feature_analytics.png"),
  },
  {
    name: "portal",
    color: "#762BDA",
    title: "Customer portal",
    description: "Communicate with your students",
    image: require("../../../../images/features/feature_portal.png"),
  },
]

const FEATURES_DATA_DE = [
  {
    name: "clients",
    color: "#319DED",
    title: "Teilnehmerverwaltung",
    description: "Teilnehmerverwaltung",
    image: require("../../../../images/features/feature_clients.png"),
  },
  {
    name: "subscriptions",
    color: "#02B799",
    title: "Anwesenheitskontrolle",
    description: "Anwesenheitskontrolle",
    image: require("../../../../images/features/feature_subscriptions.png"),
  },
  {
    name: "tasks",
    color: "#E75D49",
    title: "Task Manager",
    description: "Task Manager",
    image: require("../../../../images/features/feature_tasks.png"),
  },
  {
    name: "mobile",
    color: "#762BDA",
    title: "Mobile App",
    description: "Mobile App",
    image: require("../../../../images/features/feature_mobile.png"),
  },
  {
    name: "wages",
    color: "#F2A819",
    title: "Finanzbuchhaltung",
    description: "Finanzbuchhaltung",
    image: require("../../../../images/features/feature_wages.png"),
  },
  {
    name: "analytics",
    color: "#319DED",
    title: "Statistiken",
    description: "Statistiken",
    image: require("../../../../images/features/feature_analytics.png"),
  },
]

export const getFeaturesList = (current, lang) => {
  const FEATURES_DATA = getFeaturesData(lang)
  const featureList = current
    ? [
      ...FEATURES_DATA.filter(feature => feature.name !== current),
      FEATURES_DATA.find(feature => feature.name === current),
    ]
    : FEATURES_DATA
  return featureList.slice(0, 6)
}

export const getFeaturesData = (lang) => {
  switch (lang) {
    case 'en':
      return FEATURES_DATA_EN
    case 'de':
      return FEATURES_DATA_DE
    default:
      return FEATURES_DATA_RU
  }
}
